<template>
    <div v-if="isShow" class="ActivityWrap">
        <div class="extend" :class="{show:showExtend}">
            <router-link :to="pageJumpUrl" @click.native="$bigData('518周年庆-展开图', '518周年庆-展开图', '1')">
                <img v-if="isImgShow === false"
                     class="extendImg"
                     src="@/assets/img/activity/anniversary2021/expandAppDl.png"
                     alt="">
                <img v-if="isImgShow"
                     class="extendImg"
                     src="@/assets/img/activity/anniversary2021/expandAppDl_zs.png"
                     alt="">
            </router-link>
            <i class="iconfont icon-chahao1"
               @click.stop="closeExtend"
               @click="$bigData('518周年庆-关闭', '518周年庆-关闭', '1')"></i>
        </div>
        <div v-if="isTime"
             class="floatBtn"
             :class="{show:showFloat , activityStart: isImgShow}"
             @click="openExtend();$bigData('518周年庆-小图', '518周年庆-小图', '1')">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Activity',// 2021年周年庆
        data() {
            return {
                isImgShow: '',// 活动是否为进行中的图片
                isTime: '',// 活动是否结束
                showExtend: false,// 扩展条显示
                showFloat: false,// 浮窗显示
                nowTime: -1,// 当前时间
                pageJumpUrl: '/activity/Anniversary2021',// 页面跳转url
            };
        },
        computed: {
            // 是否显示组件
            isShow() {
                if (this.$route.path.toLowerCase() === this.pageJumpUrl.toLowerCase()) {// 跳转的页面不显示该广告
                    return false;
                } else if (this.$overseasType === true || this.$i18n.locale !== 'zhCHS') {// 海外用户或非中文不显示
                    return false;
                }
                return true;
            }
        },
        async created() {
            if (!this.isShow) {
                return;
            }
            await this.getDateTime();// 获取服务器时间数据Ajax
            setTimeout(() => {
                this.showFloat = true;// 浮窗显示
            }, 1000);
        },
        methods: {
            // 获取服务器时间数据Ajax
            getDateTime() {
                return new Promise((resolve) => {
                    this.$ajax({
                        url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                        data: {
                            act: 'getDateTime',// 获取服务器时间数据
                        },
                        success: (res) => {
                            this.nowTime = Number(res.success.dataTime);
                            // 大于5.18显示正式，小于5.18显示预热
                            if (this.nowTime > '1621267200000') {
                                this.isImgShow = true;
                            } else {
                                this.isImgShow = false;
                            }
                            // 小于5.22显示518活动，大于5.22隐藏
                            if (this.nowTime < '1621612800000') {
                                this.isTime = true;
                            } else {
                                this.isTime = false;
                            }
                            resolve();
                        }
                    });
                });
            },
            // 关闭扩展条
            closeExtend() {
                this.showExtend = false;// 显示扩展条
                this.showFloat = true;// 显示浮窗
            },
            // 展开扩展条
            openExtend() {
                this.showExtend = true;// 显示扩展条
                this.showFloat = false;// 显示浮窗
            }
        }
    };
</script>

<style lang="scss" scoped>
    .ActivityWrap {
        .extend {
            position: fixed;
            bottom: -0.5%;
            left: -100%;
            z-index: 10;
            width: 100%;
            transition: left 0.75s ease-in-out 0.25s;

            &.show {
                left: 0;
            }

            .extendImg {
                width: 100%;
                height: auto;
            }

            > .iconfont {
                position: absolute;
                top: 20%;
                right: 17.3%;
                font-size: 270%;
                color: #ababab;
                cursor: pointer;
            }
        }

        @keyframes floatBtn {
            0% {
                background-position-x: 0;
            }

            100% {
                background-position-x: -8320px;
            }
        }

        .floatBtn {
            position: fixed;
            bottom: 47px;
            left: -100%;
            z-index: 10;
            width: 130px;
            height: 178px;
            cursor: pointer;
            background-image: url("~@/assets/img/activity/anniversary2021/floatAppDl.png");
            transition: left 0.75s ease-in-out 0.25s;

            &.show {
                left: 0;
            }
        }

        .activityStart {
            background-image: url("~@/assets/img/activity/anniversary2021/floatAppDl_zs.png") !important;
        }
    }
</style>
